import {
  REQUEST_USERS_BY_WORKSPACE_SLUG,
  REQUEST_USERS_BY_WORKSPACE_SLUG_ERROR,
  RECEIVE_USERS_BY_WORKSPACE_SLUG
} from 'actions'

function initialState () {
  return {
    isRequesting: false,
    didRequestFail: false,
    hasRequested: false,
    didInvalidate: false,
    data: {}
  }
}

export default function usersById (state = initialState(), action) {
  const { type, payload } = action

  switch (type) {
    case REQUEST_USERS_BY_WORKSPACE_SLUG:
      return {
        ...state,
        isRequesting: true,
        didRequestFail: false
      }
    case REQUEST_USERS_BY_WORKSPACE_SLUG_ERROR:
      return {
        ...state,
        isRequesting: false,
        didRequestFail: true
      }
    case RECEIVE_USERS_BY_WORKSPACE_SLUG: {
      const usersById = {}

      for (const user of payload.data) {
        usersById[user.id] = {
          ...initialState(),
          data: user
        }
      }

      return {
        ...state,
        isRequesting: false,
        didRequestFail: false,
        hasRequested: true,
        data: {
          ...state.data,
          ...usersById
        }
      }
    }
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./reducers/users.js